import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import feedbackModes from '../feedbackModes.json';
import styles from './styles.module.styl';

const isDisabled = (feedbackMode, currentMode) =>
  !(currentMode === feedbackModes.NONE || currentMode === feedbackMode);

const buttonStyling = (useButtons, feedbackMode, currentFeedbackMode) => (useButtons
  ? cx(
    styles.button,
    'btn',
    'btn-transparent',
    'btn-sm',
    feedbackMode === feedbackModes.POSITIVE ? styles.buttonYes : styles.buttonNo
  )
  : cx(
    styles.text,
    currentFeedbackMode === feedbackMode && styles.active
  ));

const BooleanFeedback = ({
  handleClick,
  feedbackMode,
  currentFeedbackMode,
  useButtons
}) => (
  <Fragment>
    <button
      className={buttonStyling(useButtons, feedbackMode, currentFeedbackMode)}
      disabled={isDisabled(feedbackMode, currentFeedbackMode)}
      onClick={handleClick}
    >
      {useButtons && <span className={cx(styles.buttonIcon, 'btn-icon', `icon-budicon-${feedbackMode === feedbackModes.POSITIVE ? '470' : '471'}`)} />}
      {feedbackMode === feedbackModes.POSITIVE ? 'Yes' : 'No'}
    </button>

    {!useButtons && feedbackMode === feedbackModes.POSITIVE && <span>/</span>}
  </Fragment>
);

BooleanFeedback.propTypes = {
  handleClick: PropTypes.func.isRequired,
  feedbackMode: PropTypes.string.isRequired,
  currentFeedbackMode: PropTypes.string.isRequired,
  useButtons: PropTypes.bool.isRequired
};

export default BooleanFeedback;
